import Vue from 'vue'
import Breadcrumb from '@ostadbank-front/design-system/element/breadcrumb/index.vue'
import AppButton from '../../node_modules/@ostadbank-front/design-system/element/button/index.vue'
import AppIcon from '../../node_modules/@ostadbank-front/design-system/element/icon/index.vue'
import AppInput from '../../node_modules/@ostadbank-front/design-system/element/input/index.vue'
import AppTextarea from '../../node_modules/@ostadbank-front/design-system/element/input/textarea.vue'
import SelectBox from '../../node_modules/@ostadbank-front/design-system/element/select-box/index.vue'
import ProgressLiner from '../../node_modules/@ostadbank-front/design-system/ui/loading/progress-liner.vue'
import TagLink from '../../node_modules/@ostadbank-front/design-system/element/tag-link/index.vue'
import ModalTor from '../../node_modules/@ostadbank-front/design-system/element/modal/index.vue'

const components = {
  Breadcrumb,
  ModalTor,
  TagLink,
  AppButton,
  AppIcon,
  AppInput,
  AppTextarea,
  SelectBox,
  ProgressLiner
}

Object.entries(components).forEach(([name, component]) => {
  Vue.component(name, component)
})
